import { DynamicSchemaModel } from './dynamic-schema.model';
import { Query } from '@datorama/akita';
import { DynamicSchemaStore } from './dynamic-schema.store';

export class DynamicSchemaQuery extends Query<DynamicSchemaModel> {
  constructor(store: DynamicSchemaStore) {
    super(store);

  }
}
